import clsx from 'clsx';
import { Loading } from '@hungryroot/loading-component-primitives';

import styles from './LoadingStage.module.css';
import sharedStyles from '../shared.module.css';

export function LoadingStage(props: { visible: boolean }) {
  const { visible } = props;

  return (
    <div
      className={clsx(
        sharedStyles['visibility-transition'],
        styles['loading-stage']
      )}
      data-visible={visible || null}
    >
      <Loading variant="inline-button" />
    </div>
  );
}
